import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Scrolls the window back to the top whenever the route changes,
// so every page opens from the top instead of keeping the old scroll position.
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
